import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import { stats, heroImage } from "../mock";

export default function Hero() {
  return (
    <section className="relative pt-20">
      {/* Hero image */}
      <div className="relative w-full h-[78vh] min-h-[600px] overflow-hidden">
        <img
          src={heroImage}
          alt="Pristine commercial space"
          className="absolute inset-0 w-full h-full object-cover scale-[1.35] origin-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#143527]/25 via-transparent to-transparent" />

        {/* Floating content card */}
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 w-full">
            <div className="ml-auto w-full max-w-md lg:max-w-lg bg-[#d6e4be] rounded-3xl p-8 lg:p-10 shadow-xl fade-up">
              <div className="flex items-center gap-2 mb-5">
                <Sparkles className="w-5 h-5" style={{ color: "#143527" }} strokeWidth={1.8} />
                <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#143527]">
                  Facility Services Partner
                </span>
              </div>
              <h1 className="font-serif text-4xl lg:text-5xl leading-[1.05] text-[#143527] mb-3">
                Your single facility services partner.
              </h1>
              <p className="font-serif italic text-lg text-[#143527]/85 mb-5">
                Tidy — We handle the dirty work.
              </p>
              <p className="text-[15px] text-[#143527]/80 leading-relaxed mb-7">
                Aviation, commercial, industrial and event facilities — managed by one accountable team
                of vetted professionals across Southern Pines, Moore County and the Carolinas.
              </p>
              <Button
                className="rounded-full px-7 py-6 btn-primary text-[15px] group"
                onClick={() => {
                  const el = document.getElementById("quote");
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
              >
                Request a Quote
                <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Stats / Intro */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#e8a428] mb-4">
              Facility services done right
            </p>
            <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1] text-[#143527] mb-6">
              The facility services partner for North Carolina's most demanding spaces.
            </h2>
            <p className="text-[16px] text-[#143527]/75 leading-relaxed mb-6">
              Tidy Clean Up takes care of the cleaning so you can focus on your work. From aviation
              hangars in Moore County to offices in Raleigh and Charlotte, our crews show up trained,
              insured, and ready &mdash; for one space or every space you run.
            </p>
            <p className="text-[16px] text-[#143527]/75 leading-relaxed">
              One partner. Every facility. Always spotless.
            </p>
          </div>

          <div className="grid grid-cols-3 gap-6 lg:gap-10 lg:pl-10 lg:border-l lg:border-[#143527]/15">
            {stats.map((s) => (
              <div key={s.label}>
                <div className="font-serif text-4xl lg:text-5xl text-[#143527] leading-none mb-3">
                  {s.value}
                  <span className="text-[#e8a428]">+</span>
                </div>
                <div className="text-xs lg:text-sm text-[#143527]/70 leading-snug">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
